var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tabs.length)?_c('ul',{staticClass:"x-tabs"},_vm._l((_vm.tabs),function(item,index){return _c('li',{key:index,staticClass:"x-tab-item",class:{ 'x-tab-item-current': _vm.curTab == item.id },on:{"click":function($event){return _vm.onChangeTab(item)}}},[_c('span',[_vm._v(_vm._s(item.label))]),_c('div',{staticClass:"x-tab-line"})])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }